import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCircleEmailSelected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <circle cx={28} cy={28} r={28} fill="#56A" opacity={0.88} />
      <rect width={26} height={19} x={13} y={16} fill="#8F9DD6" rx={2} />
      <g clipPath="url(#pic_circle_email-selected_svg__a)">
        <path
          fill="#fff"
          d="M16 21c0-1.1.9-2 2-2h22a2 2 0 012 2v15a2 2 0 01-2 2H18a2 2 0 01-2-2z"
        />
        <path
          fill="#6A79B4"
          d="M24.48 28.26l1.13 1.13L16 39l-1.13-1.13zm8.99-.06l-1.14 1.13L42 39l1.13-1.13z"
        />
        <path
          fill="#6A79B4"
          d="M27.02 31.09L12.43 16.5l1.14-1.13 14.58 14.59a1.2 1.2 0 001.7 0l14.59-14.6 1.13 1.14-14.59 14.59a2.8 2.8 0 01-3.96 0"
        />
      </g>
      <defs>
        <clipPath id="pic_circle_email-selected_svg__a">
          <rect width={26} height={19} x={16} y={19} fill="#fff" rx={2} />
        </clipPath>
      </defs>
    </svg>
  );
}

SvgPicCircleEmailSelected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCircleEmailSelected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCircleEmailSelected svgRef={ref} {...props} />
));
export default ForwardRef;
